module.exports = __webpack_public_path__ + "img/fancy_charles.636ed8d7.jpg";